import { RootState } from '@box/redux/types';

export const loading = (state: RootState) => state.chats.init.loading;
export const error = (state: RootState) => state.chats.init.error;
export const userId = (state: RootState) => state.chats.init.userId;
